import type { User } from '@/api/types';

export function displayName(user?: User): string {
  if (!user) return '';
  if (user.first_name || user.last_name) return `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim();
  return user.username || user.email || '';
}

export function initials(user?: User): string {
  const name = displayName(user);
  if (!name) return '··';
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
}
